import axios from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

const base = '/api/v1/lwadmin/fund/question';

export function useGetQuestionCategories() {
  return useAxios({
    url: `${base}/categories`,
    method: 'GET',
  }, { manual: true });
}

export function useGetQuestions() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}s`,
    method: 'GET',
  }, { manual: true });
}

const execute = query => ({
  id, catId, description, fundTypes, order,
}) => query({
  ...(id ? { url: `${base}/${id}` } : {}),
  data: {
    description,
    order,
    category_id: catId,
    fund_types: fundTypes,
  },
});

export function usePostQuestion() {
  const [state, q] = useAxios({
    url: base,
    method: 'POST',
  }, { manual: true });

  return [state, execute(q)];
}

export function usePutQuestion() {
  const [state, q] = useAxios({
    url: `${base}/`,
    method: 'PUT',
  }, { manual: true });

  return [state, execute(q)];
}
